export const DEFAULT_TIME_SERIES_CHART_HEIGHT = 200;
